<template>
  <div class="divEditMain">
    <div class="c2_2_1_1">
      <!--按钮-->
      <div ref="divTest" class="divAction"><!--按钮-->
        <p class="pTopBarL">
          <b>{{ editRow.fnamestat }}</b>
        </p>
        <p class="pTopBarR">
          <i v-if="bbLoading" class="el-icon-loading" style="font-size: 21px;padding: 2px;color:blue;"/>
          <button v-for="btn in p_btns" :key="btn.vkey" @click="toAct(btn)">
            {{ btn.vlabel }}
          </button>
          <button @click="toDo(31)">关闭</button>
        </p>
      </div><!--按钮-->
      <!--编辑区-->
      <div class="divEdit">
        <!--头-->
        <div class="divEditHead">
          <div
            v-for="(mm,idx) in p_colm_top"
            v-if="!mm.vbox || mm.vbox===pBtn.vkey"
            :key="idx"
            :class="mm.vvtype===10?'editTdDiv2':'editTdDiv'"><!---->
            <!--label-->
            <p v-if="mm.vvtype!==17" class="editTdDivL">
              <b v-if="mm.vmust">*</b>
              {{ mm.vlabel }}：
            </p>
            <!--input-->
            <p v-if="mm.vread" class="w200px h20px pd1x5 bdGrayR">
              <input :value="editRow[mm.vkey]" class="bd0 pdtb2px" readonly>
            </p>
            <p v-if="!mm.vread" :class="(mm.vvtype===10?'w300px h45px':'w200px h20px')+' pd1x5 '+(comm.numIn(mm.vvtype,[7,17])?'':'bdBlueR')"><!---mm.vvtype===10?'editTdDivR2':'editTdDivR'--->
              <input v-if="mm.vvtype===2" v-model="editRow[mm.vkey]" :placeholder="mm.vhint" type="number" class="bd0 pdtb2px">
              <el-date-picker
                v-if="comm.numIn(mm.vvtype,[3,11])"
                v-model="editRow[mm.vkey]"
                :clearable="false"
                size="mini"
                type="date"
                class="iptElDt"
                value-format="yyyy-MM-dd"
              /><!--short date-->
              <el-date-picker
                v-if="mm.vvtype===4"
                v-model="editRow[mm.vkey]"
                :clearable="false"
                size="mini"
                type="date"
                class="iptElDt"
                value-format="yyyy-MM-dd HH:mm"
              /><!--long date-->

              <input v-if="mm.vvtype===5" v-model="editRow[mm.vkey]" type="hidden">
              <input
                v-if="mm.vvtype===5"
                v-model="editRow[mm.vkey]"
                type="text"
                class="bd0 pdtb2px"
                @click="p17_toPicker(mm,-1)">
              <input v-if="!mm.vvtype ||mm.vvtype===6" v-model="editRow[mm.vkey]" class="bd0 pdtb2px"><!-- -->
              <el-switch v-if="mm.vvtype===7" v-model="editRow[mm.vkey]"/> <b v-if="mm.vvtype===7 && editRow[mm.vkey]">Enable</b>
              <!--备注，多行-->
              <textarea
                v-if="mm.vvtype===10"
                v-model="editRow[mm.vkey]"
                rows="2"
                cols="130"
                class="bd0 pdtb2px"/>
              <!--按钮-->
              <button v-if="mm.vvtype===17" @click="toAct(mm)">{{ mm.vlabel }}</button>
            </p>
          </div>
        </div>
        <div style="color:red;">
          {{ errMsg }}
        </div>
        <!--文件-->
        <div class="divEditHead">
          <input
            ref="iptFile"
            type="file"
            hidden
            capture="camera"
            @change="p63_getFile($event)"><!--    accept="image/jpeg,image/png,image/gif"-->
          <p v-for="(mm,idx) in upFiles" :key="idx" class="w120px h35px bdGray">{{ idx+1 }}.{{ mm.name }}</p>
        </div>
        <br>
        <!--运行日志-->
        <br>
        <ETable
          v-if="bbCustv && voFile.data && voFile.data.length>0"
          :p_colm="voFile.colms"
          :p_list="voFile.data"
          p_title="FTP文件"/>
        <br>
        <ETable
          v-if="bbCustv && voPlc.data && voPlc.data.length>0"
          :p_colm="voPlc.colms"
          :p_list="voPlc.data"
          p_title="PLC记录"/>
        <br>
        <ETable
          v-if="bbCustv && voModb.data && voModb.data.length>0"
          :p_colm="voModb.colms"
          :p_list="voModb.data"
          p_title="MODBUS记录"/>
        <br>
        <br>
      </div>
    </div>
    <CPicker
      v-if="bbPick"
      :p_ipt="iptObj"
      :a_pickup="p17_picked"
      :a_close="p17_clsPicker"/>
  </div>
</template>
<script type="text/javascript">
import CPicker from '../c3_tools/03_picker.vue'
import COption from '../c3_tools/01_picker.vue'
import comm from '../../utils/comm'
import Editor from '../c3_tools/05_editor.vue'
import ETable from '../c3_tools/07_table.vue'
import './../../../static/c_editb.css'
export default{
  name: 'CEdit',
  components: {
    CPicker,
    COption,
    Editor,
    ETable
  },
  props: {
    p_url: {
      type: String,
      default: ''
    },
    p_colm_top: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_btns: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    p_idmenu: {
      type: Number,
      default: 0
    },
    toDo: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      iAct: 0,
      pBtn: {},
      bbPick: false,
      bbMutip: false,
      bbLoading: false,
      bbCust: (localStorage.getItem('bbCust') === 'true'),
      bbCustv: !(localStorage.getItem('bbCust') === 'true'),

      iptObj: {},
      editRow: {}, // 不包含entrys
      voFile: {}, // colm、data
      voPlc: {},
      voModb: {},

      upFiles: [],
      errMsg: ''
    }
  },
  watch: {
    p_row: {
      handler: function(newV, oldV) {
        this.prt('watch.newV.要编辑的对象', newV)
        this.prt('watch.p_row.p_colm_top', this.p_colm_top)
        if (newV.fid === this.editRow.fid && newV.iChange === this.editRow.iChange) {
          return
        }
        this.editRow = newV
        this.p01_mkEdit()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    prt(a, b) {
      console.log(`c12_equip.${a}`, b)
    },
    // 1保存 2新增 3复制 4审 5冲红 6 7 8 9删除 10 11分配1 12分配确认 13取消分配
    //  14 15 16 17 19出库(包含18)2 20取消出库 31关闭编辑 32导出
    // 40备货打印 41销售打印 42 43 44样品打印 45其他出库
    toAct(btn) {
      this.prt('toAct.btn', btn)
      this.prt('toAct.p_colm_top', this.p_colm_top)
      this.iAct = btn.vkey
      this.pBtn = btn
      if (btn.vkey === 81) this.p81_fetchEqp()
      if (btn.vkey === 62001) this.p62_updata()
      else if (btn.vkey === 63) this.p63_upgrade()
      else if (btn.vkey === 63001) this.p63_upgrade(true)
      else if (btn.vkey === 64001) this.p64_test()
      else {
        this.editRow.iAct = btn.vkey
        this.toDo(btn.vkey, this.editRow)
      }
    },
    p01_mkEdit() {
      this.editRow.iAct = 201
      this.$iPost(this.p_url, this.editRow).then(
        rs => {
          const vo1 = comm.mkColmns(rs.data.voFile)
          this.voFile = {
            data: vo1.data,
            colms: vo1.colms.filter(row => { return !row.vhidey })
          }

          const vo2 = comm.mkColmns(rs.data.voPlc)
          this.voPlc = {
            data: vo2.data,
            colms: vo2.colms.filter(row => { return !row.vhidey })
          }

          const vo3 = comm.mkColmns(rs.data.voModb)
          this.voModb = {
            data: vo3.data,
            colms: vo3.colms.filter(row => { return !row.vhidey })
          }
        }
      )
    },
    p17_toPicker(iptParam, idx) {
      this.iptObj = iptParam
      this.bbPick = true
      if (iptParam.relate) {
        iptParam[iptParam.relate] = this.editRow[iptParam.relate]
      }
      this.idx = idx
    },
    p17_picked(pkRs) {
      this.prt('p17_picked.1.input Object', this.iptObj)
      this.prt('p17_picked.2.result', pkRs)
      this.prt('p17_picked.3.tr index', this.idx)/**/
      const my = this
      var vv = ''
      if (my.iptObj.vbox === 1) { // 表体
        for (vv in pkRs) {
          // my.prt('p17_picked.6', vv)
          if (!my.editEntrys[my.idx])my.editEntrys.push({})
          if (!my.editEntrys[my.idx][vv])my.editEntrys[my.idx][vv] = pkRs[vv]
          my.editEntrys[my.idx][vv + my.iptObj.vpkey] = pkRs[vv]
        }
        my.prt('p17_picked.5.editRow', my.editEntrys[my.idx])
        my.idx++
      } else { // 表头
        for (vv in pkRs) {
          // if(vv==='fid')
          // my.prt('p17_picked.6', vv)//fid+brand,fcode+brand
          my.editRow[vv + my.iptObj.vpkey] = pkRs[vv]
        }
      }
      if (!this.iptObj.bbMutip) { // 非多选
        this.bbPick = false
        this.oOptions = []
      }
    },
    p17_clsPicker() {
      this.bbPick = false
    },
    p62_updata() {
      this.editRow.equipCmd = 'update'
      this.editRow.iAct = 62
      this.toDo(1, this.editRow)
    },
    p63_upgrade(bbOk) {
      if (bbOk) {
        this.p63_upFile().then(rs => {
          this.prt('p63_upgrade', rs)
          this.editRow.equipCmd = 'upgrade'
          this.editRow.iAct = 63
          this.editRow.fileName = this.p_idmenu + '/' + this.editRow.fid + '/' + this.upFiles[0].name
          this.toDo(1, this.editRow)
          this.upFiles = []
        })
      } else {
        this.upFiles = []
        setTimeout(() => {
          this.$refs.iptFile.click()
        }, 500)
      }
    },
    p63_getFile(event) {
      const iFile = event.target.files[0]
      const idx = iFile.name.lastIndexOf('.') + 1
      const iExtends = iFile.name.substring(idx)
      this.prt('p63_getFile.iExtends', iExtends)
      this.$refs.iptFile.value = null
      if (iExtends !== 'sh') {
        this.errMsg = '文件格式不正确'
        setTimeout(() => {
          this.errMsg = ''
        }, 3000)
        return
      }
      this.upFiles.push(iFile)
    },
    p63_upFile() {
      this.bbLoading = true
      const frmData = new window.FormData()
      this.upFiles.forEach(row => {
        frmData.append('upFiles', row)
      })
      frmData.append('fidmenu', this.p_idmenu)
      frmData.append('fidparent', this.editRow.fid)
      return this.$upFile(this.$keys().urlUpFile, frmData)
    },
    p64_test() {
      this.editRow.equipCmd = 'execute'
      this.editRow.iAct = 64
      this.toDo(1, this.editRow)
    },
    p81_fetchEqp() { /*
      if (this.bbCust) {
        this.bbLoading = true
        const ss = new Date().getTime() % 10 + 6
        setTimeout(() => {
          this.bbLoading = false
          this.bbCustv = true
        }, 1000 * ss)
      }  else {*/
      this.bbLoading = true
      this.editRow.iAct = 81
      this.$iPost(this.p_url, this.editRow).then(
        rs => {
          this.prt('p81_fetchEqp.rs', rs)
          this.p01_mkEdit()
          this.bbLoading = false
          this.bbCustv = true
        }
      ).catch(rs => {
        this.bbLoading = false
        this.prt('p81_fetchEqp.err', rs)
        this.errMsg = '更新中，请稍后再查看(' + rs + ')'
      })
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comps/c2_info/12_equip.vue